;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.communityFilter = (function () {
    const initialize = function () {
      $('.communitiesDivWrapper .js-controlLink, .communities-filter .js-controlLink').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        const desiredLook = $(this).attr('data-filter-button')
        // console.log($this, desiredLook)

        if (desiredLook === 'all') {
          // Show everything but closed.
          $('.community-card-section').removeClass('hidden')
          $('.community-card-section h4').removeClass('hidden')
          $('#section-closed').addClass('hidden')
          $('#section-title-closed').addClass('hidden')
        } else {
          $('.community-card-section').addClass('hidden')
          $('#section-' + desiredLook).removeClass('hidden')
          $('.community-card-section h4').addClass('hidden')
          $('#section-title-' + desiredLook).removeClass('hidden')
        }
        $this.parent().addClass('is-selected').siblings().removeClass('is-selected')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.communityFilter.initialize()
  })
}(jQuery, window))
